import React from "react";

const SearchIcon = (props: React.ComponentProps<"svg">) => (
  <svg
    width="15"
    height="15"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.75 13.75L10.4926 10.4926L10 9.92424M10 9.92424C10.9279 8.97733 11.5 7.68048 11.5 6.25C11.5 3.35051 9.14949 1 6.25 1C3.35051 1 1 3.35051 1 6.25C1 9.14949 3.35051 11.5 6.25 11.5C7.71902 11.5 9.04711 10.8966 10 9.92424Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SearchIcon;
